// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l_500","colMin":"styles_colMin__34T66"};